import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { TSelectedApp, ISelectedAppActions } from "@workspace/shared/core/types";

const initState: TSelectedApp = {
  appKey: "",
};

interface SelectedAppState extends TSelectedApp, ISelectedAppActions {}

export const selectedAppStore = create<SelectedAppState>()(
  persist(
    (set) => ({
      ...initState,
      setSelectedAppState: (payload) => set({ [payload.key]: payload.value }),
      clearSelectedAppState: () => set({ ...initState }),
    }),
    {
      name: "selected-app-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const getAppKey = () => {
  const state = selectedAppStore.getState();
  return state.appKey;
};
